import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { Image, ScrollToTop } from '@bd/bdcore-utilities';
// import { SanitizeHtml } from '@bd/bdcore-utilities';
import { Link } from '@bd/bdcore-named-routes';
import ContactModal from '../../components/ContactModal';

function Footer({ builder, community, agent, metro, widget }) {
  const phone = _.get(agent, 'telephone') || _.get(community, 'osc_phone') || _.get(metro, 'osc_phone') || _.get(widget, 'header[0].phone');
  return (
    <div className="footer-wrapper">
      <ScrollToTop className="scroll-to-top">
        <img src="/images/icon-right-arrow-white.svg" alt="" />
      </ScrollToTop>

      <div className="footer">
        <div className="container">
          <div className="row">
            <div className="box-1">
              <p>
                <strong>{_.get(builder, 'name')}</strong><br />
                {_.get(builder, 'address.streetAddress')}<br />
                {_.get(builder, 'address.addressLocality')}, {_.get(builder, 'address.addressRegion')} {_.get(builder, 'address.addressPostalCode')}<br />
                {_.get(builder, 'phone')}
              </p>
            </div>
            <div className="box-2">
              <ul className="footer-links">
                <li><Link name="communities">Communities</Link></li>
                <li><Link name="homes">Homes</Link></li>
                <li><Link name="plans">Floor Plans</Link></li>
                <li><Link name="building-process">Buying Guide</Link></li>
                <li><Link name="difference">About Us</Link></li>
                <li><Link name="contact-us">Contact Us</Link></li>
              </ul>
              <p>
                ©{(new Date()).getFullYear()} | {_.get(builder, 'name')}. All Rights Reserved<br />
                Site by <a href="http://builderdesigns.com" target="_blank" rel="noopener noreferrer">Builder Designs</a>
              </p>
            </div>
            <div className="col box-4">
              <img src="/images/icon-eho.svg" alt="Equal Housing Opportunity Logo" />
            </div>
          </div>
        </div>
        <div className="anchored-footer-mobile">
          <ContactModal>
            <Image
              src={_.get(agent, 'logo.contentUrl')}
              alt="Online Sales Counselor"
              className="osc"
              width={100}
              height={77}
              exact
            />
          </ContactModal>
          <div className="icon-wrapper">
            <div className="icon">
              <a href={`tel:${phone.replace(/[^0-9]/g, '')}`}>
                <img src="/images/icon-mobile-call.svg" alt="Call" />
              </a>
              <h4>Call</h4>
            </div>
            <div className="icon">
              <ContactModal>
                <img src="/images/icon-mobile-email.svg" alt="Email" className="email" />
              </ContactModal>
              <h4>Email</h4>
            </div>
            <div className="icon">
              <a href={`sms:${phone.replace(/[^0-9]/g, '')}`}>
                <img src="/images/icon-mobile-text.svg" alt="Text" className="text" />
              </a>
              <h4>Text</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

Footer.propTypes = {
  builder: PropTypes.object,
  agent: PropTypes.object,
  widget: PropTypes.object,
  community: PropTypes.object,
  metro: PropTypes.object,
};

Footer.defaultProps = {
  builder: undefined,
  agent: undefined,
  community: undefined,
  widget: undefined,
  metro: undefined,
};

export default withData(
  {
    builder: true,
    community: true,
    agent: true,
    widget: 'contact_banners',
    metro: true,
  },
  {
    required: {
      builder: true,
      agent: true,
      widget: true,
    },
  },
)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/index.js